import React from 'react'

import BodyCell from '../BodyCell'
import SegmentCell from '../SegmentCell'

import { TableRow, TableColumn } from 'components_new/molecules/Table'

interface BodyRowProps {
  columns: TableColumn[]
  expandedPathSet: Set<string>
  level?: number
  item: TableRow
  longestPath: number
  measureSegmentCell?: (cell: HTMLTableCellElement | null) => void
  row: number
  scaleFactor: number
  segmentMaxChars: number | null
  segmentWidth: number
  onToggleExpanded: (path: string, expanded: boolean) => void
  verticalDividers: boolean
}

const BodyRow = (props: BodyRowProps) => {
  const {
    columns,
    expandedPathSet,
    item,
    longestPath,
    measureSegmentCell,
    row,
    scaleFactor,
    segmentMaxChars,
    segmentWidth,
    onToggleExpanded,
    verticalDividers
  } = props

  return (
    <>
      <SegmentCell
        divider={verticalDividers}
        expandedPathSet={expandedPathSet}
        longestPath={longestPath}
        item={item}
        measureRef={measureSegmentCell}
        scaleFactor={scaleFactor}
        onToggleExpanded={onToggleExpanded}
        maxChars={segmentMaxChars}
        variant="body"
      />
      {columns.map((column, colIndex) => {
        const cell = column.cells[row]

        return (
          <BodyCell
            key={`row-${row}-column-${colIndex}`}
            color={cell.color}
            divider={verticalDividers}
            increaseIsPositive={cell.increaseIsPositive}
            label={cell.label}
            percentageDiff={cell.percentageDiff}
            scaleFactor={scaleFactor}
            showTrendTag={cell.showTrendTag}
            status={cell.status}
            // the total column is pinned right after the segment column
            stickyLeft={column.isTotal ? segmentWidth : undefined}
            type={column.type}
          />
        )
      })}
    </>
  )
}

export default BodyRow
